import dynamic from 'next/dynamic';
import { useState } from 'react';
import type { Filters, ResultData, ResultItem } from '@/domain';
import { MapCard } from '../mapCard/MapCard';

const DynamicMap = dynamic(() => import('shared/map/ClientSideMap'), {
    loading: () => <div className="map-placeholder" />,
    ssr: false,
});

type FhhFullScreenMapProps = {
    filters: Filters;
    data: ResultData;
    populateMapResults: (filters: Filters) => void;
    onFilterChanged: (filters: Filters) => void;
    populateMapObject: (adId: string) => void;
    selectedAdId?: string;
    selectedAdData: ResultItem | null;
};

export const FhhFullScreenMap = ({
    filters,
    data,
    populateMapResults,
    onFilterChanged,
    selectedAdId,
    populateMapObject,
    selectedAdData,
}: FhhFullScreenMapProps) => {
    const [poiClickId, setpoiClickId] = useState<string | null>(null);
    const updateMapFilters = (bounds: { sw: [number, number]; ne: [number, number] }) => {
        onFilterChanged({
            lat_sw: String(bounds.sw[1]),
            lng_sw: String(bounds.sw[0]),
            lat_ne: String(bounds.ne[1]),
            lng_ne: String(bounds.ne[0]),
        });
        populateMapResults({
            ...filters,
            lat_sw: String(bounds.sw[1]),
            lng_sw: String(bounds.sw[0]),
            lat_ne: String(bounds.ne[1]),
            lng_ne: String(bounds.ne[0]),
        });
    };

    const onPoiClick = (adId: string) => {
        setpoiClickId(adId);
        populateMapObject(adId);
    };

    const displayClientSideClusters = data?.stats?.numResults ? +data?.stats?.numResults < 5000 : false;

    const mapData = data?.listMap || data?.resultItems || [];

    let primaryPOI = displayClientSideClusters
        ? mapData?.map((item) => ({
              id: item.id,
              coordinates: [item.longitude, item.latitude],
              name: item.heading,
          }))
        : [];

    const serverSideClusters = displayClientSideClusters
        ? []
        : data?.heatmap?.map((heatmap) => ({
              id: heatmap.id,
              name: heatmap.numberOfEntries,
              coordinates: [heatmap.longitude, heatmap.latitude],
              count: Number.parseInt(heatmap.numberOfEntries.replace('+', '')),
          }));

    const selectedAd = primaryPOI?.find((ad) => selectedAdId === ad.id);
    const selectedPois = selectedAd ? [selectedAd] : [];
    primaryPOI = selectedAd ? primaryPOI?.filter((ad) => ad.id !== selectedAdId) : primaryPOI;

    return (
        <DynamicMap
            id="result-list-map"
            className="result-list-map map"
            // @ts-expect-error
            selectedPois={selectedPois}
            onUpdateBounds={updateMapFilters}
            // @ts-expect-error
            primaryPois={primaryPOI}
            onPinClick={onPoiClick}
            // @ts-expect-error
            serverSideClusters={serverSideClusters}
            hasClustering
            // @ts-expect-error gps stuff is possibly undefined, but it's ok...
            initialBounds={{ sw: [+filters.lng_sw, +filters.lat_sw], ne: [+filters.lng_ne, +filters.lat_ne] }}>
            {poiClickId && selectedAdData && (
                <div className="mapboxgl-ctrl-bottom-center">
                    <MapCard closeCard={() => setpoiClickId(null)} selectedAd={selectedAdData} />
                </div>
            )}
        </DynamicMap>
    );
};
